module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ko":{"cancel":"취소","create":"내 정보 등록하기","update":"내 정보 수정하기","edit":"수정","apply":"적용","reset":"해제"}}')
  delete Component.options._Ctor
}
